import {
	Alert,
	Button,
	designTokens,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Modalv2
} from "@itandi/itandi-bb-ui";

type Props = {
	deleteCount: number;
	onClose: () => void;
	onDelete: () => void;
};

export function ReportBulkDeleteModal({
	deleteCount,
	onClose,
	onDelete
}: Props) {
	return (
		<Modalv2 isOpen onClose={onClose} size="s">
			<ModalHeader title="一括削除" />
			<ModalBody>
				{`${deleteCount}件の画像を削除します。`}
				<Alert mt={designTokens["spacing/m"]} variant="warning">
					他社がアップロードした画像は削除されません。
				</Alert>
			</ModalBody>
			<ModalFooter
				leftArea={
					<Button onClick={onClose} type="button" variant="secondary">
						キャンセル
					</Button>
				}
				rightArea={
					<Button
						onClick={() => {
							onClose();
							onDelete();
						}}
						type="button"
						variant="primary"
					>
						削除
					</Button>
				}
			/>
		</Modalv2>
	);
}
